const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://1g8cj3v0yh.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://q7fuljjvb7.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.4',
    HOSTNAME: 'https://company.staging.barrick.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.barrick.forwoodsafety.com',
    WEBSOCKET: 'wss://mdwceyl46c.execute-api.us-west-2.amazonaws.com/staging'
  },
};

export default config;